module.exports = __webpack_public_path__ + "img/SO.2c527a9e.svg";